// in src/Dashboard.js
import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Title, useGetIdentity, useGetList, useGetOne, useListContext } from "react-admin";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { JSONTree } from "react-json-tree";
import TotalApplicationGraph from "../Ats/TotalApplicationGraph";
import { useParams } from "react-router";

import { LineChart, Line } from "recharts";
import { NumericFormat } from "react-number-format";

const StatsAndGraphVerification = () => {
  
  const {filterValues}=useListContext();
  const {
    data,
    isLoading: loadingdocuploadmanagementstats,refetch
} = useGetList(
    "verificationmanagementstats",
    {
       filter:filterValues
    }
);
  const [toggleButton, setToggleButton] = React.useState(true);

  if (loadingdocuploadmanagementstats) {
    return <div>Loading...</div>; 
  }
  const statusCountData:any =data;

  const percentageHandler = (value: number, type: string, totalPerCount?: string) => {
    
    const application =
      (statusCountData?.filter((item) => item.ID == 13)[0]?.Count || 0) +
      (statusCountData?.filter((item) => item.ID == 14)[0]?.Count || 0) +
      (statusCountData?.filter((item) => item.ID == 15)[0]?.Count || 0);
    const docUpload =
      (statusCountData?.filter((item) => item.ID == 16)[0]?.Count || 0) +
      (statusCountData?.filter((item) => item.ID == 17)[0]?.Count || 0) +
      (statusCountData?.filter((item) => item.ID == 18)[0]?.Count || 0);
    const total = type === "Application" ? application : docUpload;
    const percentage =
      value && value > 0 && total && total > 0 ? (value / total) * 100 : 0;
    // return Math.round(percentage) + "%";
    // return percentage.toFixed(2) + "%";
    if (totalPerCount) {
      return percentage;
    } else {
      return percentage.toFixed(2) + "%";
    }
  };

  const totalPercentageCountHandler = (type: string) => {
    
    const forApplication: any = (value: number) => {
      const per = percentageHandler(
        statusCountData?.filter((item) => item.ID == value)[0]?.Count,
        "Application",
        "totalPerCount"
      );
      return per;
    };
    const forDocUpload: any = (value: number) => {
      const per = percentageHandler(
        statusCountData?.filter((item) => item.ID == value)[0]?.Count,
        "DocUpload",
        "totalPerCount"
      );
      return per;
    };
    let totalPercentageCount: number = 100;
    if (type == "Application") {
      totalPercentageCount =
        forApplication(13) + forApplication(14) + forApplication(15);
    } else {
      totalPercentageCount =
        forDocUpload(16) + forDocUpload(17) + forDocUpload(18);
    }
    return Math.round(totalPercentageCount) + "%";
  };

  return (
    <>
      <div className="">
        {true && statusCountData && (
          <div className="app-count-table mr-t30 mr-b30">
            <table>
              <tbody>
                <tr>
                  {!toggleButton &&
                    true && (
                      <td colSpan={3} className="light-green-td">
                        <div className="ta-no-block d-flex align-items-center justify-content-center">
                          <p className="per_count">
                            {totalPercentageCountHandler("Application")}
                          </p>
                          <h4 className="color-green">
                            {statusCountData?.filter((item) => item.ID == 13)[0]
                              ?.Count +
                              statusCountData?.filter((item) => item.ID == 14)[0]
                                ?.Count +
                              statusCountData?.filter((item) => item.ID == 15)[0]
                                ?.Count
                              ? statusCountData?.filter(
                                (item) => item.ID == 13
                              )[0]?.Count +
                              statusCountData?.filter(
                                (item) => item.ID == 14
                              )[0]?.Count +
                              statusCountData?.filter(
                                (item) => item.ID == 15
                              )[0]?.Count
                              : 0}
                          </h4>
                          <small className="color-green mr-l10">
                            Completed
                          </small>
                        </div>
                      </td>
                    )}
                  {(toggleButton ||
                    true) && (
                      <td colSpan={3} className="light-green-td">
                        <div className="ta-no-block d-flex align-items-center justify-content-center">
                          <p className="per_count">
                            {totalPercentageCountHandler("DocUpload")}
                          </p>
                          <h4 className="color-green">
                            {(statusCountData?.filter((item) => item.ID == 16)[0]
                              ?.Count || 0) +
                              (statusCountData?.filter((item) => item.ID == 17)[0]
                                ?.Count || 0) +
                              (statusCountData?.filter((item) => item.ID == 18)[0]
                                ?.Count || 0 )
                              ? ((statusCountData?.filter(
                                (item) => item.ID == 16
                              )[0]?.Count || 0 ) +
                              statusCountData?.filter(
                                (item) => item.ID == 17
                              )[0]?.Count || 0) +
                              (statusCountData?.filter(
                                (item) => item.ID == 18
                              )[0]?.Count || 0)
                              : 0}
                          </h4>
                          <small className="color-green mr-l10">
                            Completed
                          </small>
                        </div>
                      </td>
                    )}
                </tr>
                {!toggleButton && true && (
                  <tr>
                    <td className="light-green-td">
                      <div className="ta-no-block">
                        <p className="per_count">
                          {percentageHandler(
                            statusCountData?.filter((item) => item.ID == 13)[0]
                              ?.Count,
                            "Application"
                          )}
                        </p>
                        <h4 className="color-green">
                          {
                            statusCountData?.filter((item) => item.ID == 13)[0]
                              ?.Count
                          }
                        </h4>
                        <small className="color-green">Approved</small>
                      </div>
                    </td>
                    <td className="light-orange-td">
                      <div className="ta-no-block">
                        <p className="per_count">
                          {percentageHandler(
                            statusCountData?.filter((item) => item.ID == 14)[0]
                              ?.Count,
                            "Application"
                          )}
                        </p>
                        <h4 className="color-orange">
                          {
                            statusCountData?.filter((item) => item.ID == 14)[0]
                              ?.Count
                          }
                        </h4>
                        <small className="color-orange">Conditional</small>
                      </div>
                    </td>
                    <td className="light-red-td">
                      <div className="ta-no-block">
                        <p className="per_count">
                          {percentageHandler(
                            statusCountData?.filter((item) => item.ID == 15)[0]
                              ?.Count,
                            "Application"
                          )}
                        </p>
                        <h4 className="color-red">
                          {
                            statusCountData?.filter((item) => item.ID == 15)[0]
                              ?.Count
                          }
                        </h4>
                        <small className="color-red">Denied</small>
                      </div>
                    </td>
                  </tr>
                )}
                {(toggleButton || true) && (
                  <tr>
                    <td className="light-green-td">
                      <div className="ta-no-block">
                        <p className="per_count">
                          {percentageHandler(
                            statusCountData?.filter((item) => item.ID == 16)[0]
                              ?.Count,
                            "DocUpload"
                          )}
                        </p>
                        <h4 className="color-green">
                          {
                            statusCountData?.filter((item) => item.ID == 16)[0]
                              ?.Count || 0
                          }
                        </h4>
                        <small className="color-green">Verified</small>
                      </div>
                    </td>
                    <td className="light-orange-td">
                      <div className="ta-no-block">
                        <p className="per_count">
                          {percentageHandler(
                            statusCountData?.filter((item) => item.ID == 17)[0]
                              ?.Count,
                            "DocUpload"
                          )}
                        </p>
                        <h4 className="color-orange">
                          {
                            statusCountData?.filter((item) => item.ID == 17)[0]
                              ?.Count || 0
                          }
                        </h4>
                        <small className="color-orange">Doc Req</small>
                      </div>
                    </td>
                    <td className="light-red-td">
                      <div className="ta-no-block">
                        <p className="per_count">
                          {percentageHandler(
                            statusCountData?.filter((item) => item.ID == 18)[0]
                              ?.Count,
                            "DocUpload"
                          )}
                        </p>
                        <h4 className="color-red">
                          {
                            statusCountData?.filter((item) => item.ID == 18)[0]
                              ?.Count || 0
                          }
                        </h4>
                        <small className="color-red">Unverifiable</small>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {/* Code new end here */}
    </>
  );
};

export default StatsAndGraphVerification;
